import thunkMiddleware from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';

import reducer from 'app/modules';
import analyticsMiddleware from 'infrastructure/middleware/analyticsMiddleware';
import cookiesMiddleware, { updateInitialStateFromCookies } from 'infrastructure/middleware/cookiesMiddleware';

export default function configureStore(context, initialState) {
  const middlewares = [];

  // read stored data in cookies and merge it with the initial state
  initialState = updateInitialStateFromCookies(context, initialState);

  middlewares.push(thunkMiddleware.withExtraArgument({ ...context.gateways }));
  middlewares.push(analyticsMiddleware(context));
  // middlewares.push(errorMiddleware(context));
  middlewares.push(cookiesMiddleware(context));

  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger);
  }

  return compose(applyMiddleware(...middlewares))(createStore)(reducer, initialState);
}
